import React from 'react'
import ImageNotAvailable from '../../../assets/image-not-available.png'
import CustomImage from 'src/components/customImage/customImage'
import { Dropdown } from 'react-bootstrap'
import OptionsBtn from '../../../assets/elipsis-icon.svg'

const ChannelCard = ({
  cardImage = '',
  title = '',
  // subscribersCount = '',
  category = '',
  pricing = '',
  actionButtonOptions = [],
}) => {
  const spanStyles = {
    background: '#e5e5e5',
    color: ' #707070',
    padding: '.1ch 1ch',
    borderRadius: '2px',
    fontSize: 'max(.5vw,8px)',
  }
  return (
    <div
      style={{
        width: '17.14%',
        aspectRatio: '251/189',
        boxShadow: '3px 3px 8px 0 rgba(0, 0, 0, 0.2)',
        border: `.5px solid #707070`,
        borderRadius: '4px',
        // overflow: 'hidden',
      }}
      tabIndex={0}
    >
      <div className="relative" style={{ height: '74%' }}>
        <CustomImage
          className="card-img-top"
          imageUrl={cardImage}
          loaderStyle={{ height: '100%' }}
          errorPlaceholder={ImageNotAvailable}
          alt={'Asset'}
          imgStyle={{
            height: '100%',
            width: '100%',
          }}
        />
      </div>
      <div
        className="d-flex justify-content-between bg-white channel-card-focus"
        style={{ height: '26%' }}
      >
        <div style={{ fontSize: '10px', width: '88%' }} className="px-3">
          <h6
            className="line-clamp-1"
            style={{ fontSize: 'max(.74vw,11px)', margin: '.4ch 0 .6ch', color: '#000' }}
          >
            {title}
          </h6>
          <div className="d-flex" style={{ gap: '0 .2vw' }}>
            {/* <span style={spanStyles}>{subscribersCount}</span> */}
            {category.map((categoryName, idx) => (
              <span style={spanStyles} key={idx} className="line-clamp-1">
                {categoryName}
              </span>
            ))}
            <span style={spanStyles}>{pricing}</span>
          </div>
        </div>
        <div
          style={{
            width: '10%',
            fontSize: '20px',
            fontWeight: '700',
            cursor: 'pointer',
          }}
          className="d-flex justify-content-center align-items-center position-relative channel-menu-dots"
        >
          <Dropdown align="center" className="">
            <Dropdown.Toggle variant="ghost" className="" id="revenue-dropdown">
              <img src={OptionsBtn} alt="OptionsBtn" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="p-0 w-fit">
              {actionButtonOptions.map((info, idx) => (
                <Dropdown.Item
                  key={idx}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                  onClick={() => {
                    info?.btnFunction()
                  }}
                  className="d-flex "
                >
                  {info?.logo ? info?.logo : null}
                  {info?.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

export default ChannelCard

/*
.on-card-hover - Applies the hover effect to the card
.on-card-selected - Applies the selected effect to the card
.play-icon - Applies the play icon effect to the card which is of type "video", it is absolute on the thumbnail (search for the class for more)

displayAsListItem - display the card as a list item(if true) or a grid item(if false)

publish_time - start
live_exp_tiem - end time

/////// for live
*/
